<template>
  <div ref="tablePage" style="height: 100%">
    <!-- 面包屑导航 -->
    <div class="topNav">
      <div class="navFormWrapper">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ path: '/homePage' }"
            >首页</el-breadcrumb-item
          >
          <el-breadcrumb-item>评价管理</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
    </div>
    <el-table
      :data="tableList"
      style="width: 100%; margin-top: 2vh"
      border
      size="mini"
      :header-cell-style="{
        background: '#fff',
        height: '50px',
        color: '#909399',
        fontSize: '16px',
        fontFamily: 'Arial, sans-serif',
      }"
    >
      <el-table-column prop="cou_name" label="被评价销售" align="center" />
      <el-table-column prop="content" label="评价内容" align="center" />
      <el-table-column prop="cou_name" label="评价人" align="center">
        <template slot-scope="scope">
          <span class="cou_name" @click.stop="details(scope.row)">{{
            scope.row.mem_name
          }}</span>
        </template>
      </el-table-column>
      <el-table-column label="评分" align="center">
        <template slot-scope="scope">
          <el-rate
            v-model.number="scope.row.score"
            disabled
            show-score
            text-color="#ff9900"
          ></el-rate>
        </template>
      </el-table-column>
      <el-table-column prop="status" label="状态" align="center">
        <template slot-scope="scope">
          <el-switch
            v-model="scope.row.status"
            :active-value="1"
            :inactive-value="0"
            @change="changeStatus(scope.row)"
          ></el-switch>
        </template>
      </el-table-column>
    </el-table>
    <pagination
      v-show="total > 0"
      :total="total"
      :page.sync="searchForm.page"
      :limit.sync="searchForm.size"
      @pagination="initList"
    />
    <el-dialog
      :title="title"
      :visible.sync="addOrEditOpen"
      :close-on-click-modal="false"
      width="45%"
      class="dialogHeight2 global-dialog-position"
      :before-close="getout"
      style="margin-top: -10vh"
      :lock-scroll="false"
      :append-to-body="true"
    >
      <el-form ref="form" :model="form" label-width="120px">
        <el-row>
          <el-col :span="24">
            <el-form-item label="被评价人">
              <el-input
                v-model="form.mem_name"
                autocomplete="off"
                placeholder="请输入"
              />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="评价人">
              <el-input
                v-model="form.cou_name"
                autocomplete="off"
                placeholder="请输入"
              />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="评价内容">
              <el-input
                v-model="form.content"
                autocomplete="off"
                placeholder="请输入"
              />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="评分">
              <el-input
                v-model="form.score"
                autocomplete="off"
                placeholder="请输入"
              />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="联系电话">
              <el-input
                v-model="form.mobile"
                autocomplete="off"
                placeholder="请输入"
              />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="评价标签">
              <el-select
                v-model="form.evaluate_tag"
                multiple
                style="width: 100%"
                placeholder="请选择"
                filterable
              >
                <el-option
                  v-for="item in tagList"
                  :key="item.id"
                  :label="item.title"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </el-dialog>
  </div>
</template>
    
    <script>
import tableCommon from "../../../mixins/table-common";
import imgUpload from "../../components/uploadImg.vue";
import { getCookie } from "../../utils/util";
import { getpriseList, editprise } from "../../api/evaluate";
import { gettagList } from "../../api/personTag";

export default {
  mixins: [tableCommon],
  components: {
    imgUpload,
  },
  data() {
    return {
      // 请求地址api
      api: {
        list: getpriseList,
        edit: editprise,
      },
      // 规则验证
      rules: {
        title: [{ required: true, message: "请输入名称", trigger: "blur" }],
      },
      // 传参
      form: {
        status: "1",
      },
      // 弹窗标题
      title: "评价详情",
      addOrEditOpen: false,
      // 查询参数
      searchForm: {
        page: 1,
        size: 10,
      },
      tableData: [],
      // 上传头文件
      headers: {
        Authorization: "Bearer " + getCookie("logintoken"),
      },
      // 图片上传地址
      uploadImgUrl: process.env.VUE_APP_URL + "/admin/uploadFile",
      imgFirst: false,
      upImg: false,
      // 评价标签
      tagList: {},
    };
  },
  beforeUpdate() {
    this.tableList.forEach((item) => {
      item.score = Number(item.score);
    });
  },
  mounted() {
    this.gettagLists();
  },
  methods: {
    // 评价标签
    gettagLists() {
      const form = {
        select: 1,
        status: 1,
      };
      gettagList(form).then((res) => {
        this.tagList = res.data.records;
      });
    },
    details(res) {
      this.form = JSON.parse(JSON.stringify(res));
      if (this.form.evaluate_tag) {
        this.form.evaluate_tag = this.form.evaluate_tag.split(",").map(Number);
      }
      this.addOrEditOpen = true;
    },
    getout() {
      this.addOrEditOpen = false;
    },
    // 状态修改
    changeStatus(res) {
      this.form = JSON.parse(JSON.stringify(res));
      // this.handleEdit();
      this.actionType = "edit";
      const {
        content,
        cou_name,
        created_at,
        evaluate_tag,
        mem_name,
        mobile,
        score,
        updated_at,
        ...rest
      } = this.form;
      this.form = rest;
      editprise(this.form).then((msg) => {
        if (msg.code !== 200) return this.$message("获取状态失败");
      });
    },
    // 重置
    reset() {
      this.form = {
        status: undefined,
        title: undefined,
      };
    },
  },
};
</script>
    <style scoped>
.cou_name {
  color: #409eff;
  cursor: pointer;
  transition: color 0.3s ease;
}
/deep/.dialogHeight .el-dialog__body {
  height: 100%;
  overflow: hidden;
}
.chooseImg {
  display: flex;
  align-items: center;
}
/deep/.el-table,
.el-table th,
.el-table td {
  border-radius: 10px;
  -webkit-font-smoothing: antialiased;
  text-rendering: optimizeLegibility;
  font-size: 16px;
  font-family: Times, "Times New Roman";
  /* font-weight: 600; */
}
.topNav {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: #fff;
  padding: 20px 20px;
  border-radius: 10px;
}

.navFormWrapper {
  display: flex;
  align-items: center;
}
.avatar-wrapper {
  position: relative;
}

.avatar-wrapper img.avatar {
  max-width: 100%;
  max-height: 100%;
}

.avatar-wrapper .el-icon-close {
  position: absolute;
  top: 5px;
  right: 5px;
  font-size: 18px;
  color: #fff;
  background-color: rgba(0, 0, 0, 0.5);
  padding: 5px;
  border-radius: 50%;
  cursor: pointer;
}
.navFormWrapper {
  display: flex;
  align-items: center;
}
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 150px;
  height: 150px;
  line-height: 150px;
  text-align: center;
  border: 1px solid #dcdfe6;
}
.avatar {
  width: 150px;
  height: 150px;
  display: block;
}
.el-icon-close {
  position: absolute;
  top: 0;
  right: 7vh;
  cursor: pointer;
}
.closes {
  right: 54vh;
}
.el-icon-close:hover {
  color: #409eff;
}
.el-icon-close2 {
  position: absolute;
  top: 0;
  right: 55vh;
  cursor: pointer;
}
</style>


// WEBPACK FOOTER //
// src/views/identity/evaluate.vue